import { z } from 'zod'

export const groupStatsResponseSchema = z.object({
  totalYouOwe: z.number(),
  totalOwedToYou: z.number(),
  currency: z.string(),
  totalExpenses: z.number().int(),
  yourExpenses: z.number().int(),
  othersExpenses: z.number().int(),
})

export type GroupStatsResponseDto = z.infer<typeof groupStatsResponseSchema>
